'use client'

/**
 * Purpose: Survey welcome page — start questionnaire or switch to photo capture.
 * Inputs: Translated copy, photoEnabled flag, and navigation callbacks.
 * Outputs: Primary CTA to begin survey; optional secondary CTA for photo path.
 */

import HoverGradientButton from '@/components/buttons/HoverGradientButton/HoverGradientButton'

export function SurveyWelcomePage({
  title,
  description,
  startSurveyText,
  takePhotoInsteadText,
  photoEnabled,
  onStart,
  onTakePhoto,
}: {
  title: string
  description: string
  startSurveyText: string
  takePhotoInsteadText: string
  photoEnabled: boolean
  // When true, show secondary CTA to start the photo survey path.
  onStart: () => void
  onTakePhoto: () => void
}) {
  // Centered hero with primary questionnaire CTA and optional photo path.
  return (
    <div id="survey-welcome-page" className="flex flex-col items-center text-center pt-[10vh] gap-8">
      <div>
        <h1 id="survey-welcome-page-title" className="mb-4">
          {title}
        </h1>
        <p id="survey-welcome-page-description" className="text-black text-sm">
          {description}
        </p>
      </div>
      <div id="survey-welcome-page-actions" className="flex flex-col items-center gap-3 w-full max-w-xs">
        <HoverGradientButton onClick={onStart} className="cursor-pointer w-full">
          {startSurveyText}
        </HoverGradientButton>
        {photoEnabled && (
          // Gated by image-survey feature flag — hidden when flag is off.
          <HoverGradientButton variant="outline" onClick={onTakePhoto} className="cursor-pointer w-full">
            {takePhotoInsteadText}
          </HoverGradientButton>
        )}
      </div>
    </div>
  )
}
